import PropTypes from 'prop-types';

const WidgetPagePropTypes = {
  // redux state
  app: PropTypes.object.isRequired,

  // redux actions
  answer: PropTypes.func.isRequired,
  checkValidEmail: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired,
  complete: PropTypes.func.isRequired,
  createError: PropTypes.func.isRequired,
  getAnswers: PropTypes.func.isRequired,
  getBankName: PropTypes.func.isRequired,
  getBraintreeToken: PropTypes.func.isRequired,
  getMicrodeposits: PropTypes.func.isRequired,
  getPlaidToken: PropTypes.func.isRequired,
  getFundingAccounts: PropTypes.func.isRequired,
  getUser: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  queryGetInitialFunding: PropTypes.func.isRequired,
  queryGetUser: PropTypes.func.isRequired,
  resolveError: PropTypes.func.isRequired,
  saveDebit: PropTypes.func.isRequired,
  saveManualAch: PropTypes.func.isRequired,
  saveDebitCard: PropTypes.func.isRequired,
  verifyACHLater: PropTypes.func.isRequired,
  verifyDebitLater: PropTypes.func.isRequired,
  verifyDebitNow: PropTypes.func.isRequired,
  analytics: PropTypes.object.isRequired,

  // react router
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default WidgetPagePropTypes;
